import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ItemDto } from "src/dtos/item/itemDto";

import { DropDownForm } from "src/components/common/form/DropdownForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useSYS4120_R01Store } from "./Store_SYS4120_R01";
import { ImageForm } from "src/components/common/form/ImageForm";
import { defaultSYS4120_R01Dto, SYS4120_R01Dto } from "./Dto_SYS4120_R01";
import { searchCustomer } from "src/apis/customerApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import useUiuxStore from "src/store/useUiuxStore";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { CodeForm } from "src/components/common/form/CodeForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { formatDate } from "src/utils/string/stringUtil";
import { getEmployeeList } from "src/apis/employeeApi";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import DateRangePickerForm from "src/components/common/form/date/DateRangePickerForm";
import { DateRange } from "react-day-picker";
import { CheckboxButtonForm } from "src/components/common/form/checkbox/CheckboxButtonForm";
import { TextareaForm } from "src/components/common/form/input/TextareaForm";

interface Props {
	defaultSYS4120_R01Row: SYS4120_R01Dto;
}

export const Info_SYS4120_R01 = ({ defaultSYS4120_R01Row }: Props) => {

	const { setCodeSearchModalProps } = useUiuxStore();
	const { selectedSYS4120_R01, editSYS4120_R01, setEditSYS4120_R01 } = useSYS4120_R01Store();

	const [writerDtVisible, setWriterDtVisible] = useState(false);
	const [writerDtPickerPos, setWriterDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput'; // 게시자 포커스 ID 추가

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'writerEmpNo',
			category: '사원번호',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo : 'writerEmpNo',
				empNm : 'writerEmpNm',
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editSYS4120_R01?.writerEmpNo || '',
				empNm: editSYS4120_R01?.writerEmpNm || '',
			}),
		}
	];
	
	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editSYS4120_R01,
		setEditData: setEditSYS4120_R01,
		defaultData: defaultSYS4120_R01Row,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1020_R01'
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		if (!editSYS4120_R01) return;

		setEditSYS4120_R01({ ...editSYS4120_R01, [name]: value });
	};
	
	const handleDateChange = useCallback((field: keyof SYS4120_R01Dto, value: any) => {
	
		setEditSYS4120_R01({
			...defaultSYS4120_R01Row,
			...editSYS4120_R01,
			[field]: value ? formatDate(value) : formatDate(new Date()), // noticeDateRange는 새로운 값(value)으로 업데이트되지만...
		});
	}, [editSYS4120_R01]);

	const handleDateRangeChange = useCallback((value: DateRange) => {
		setEditSYS4120_R01({
			...defaultSYS4120_R01Row,
			...editSYS4120_R01,
			noticeDateRange: value,
			noticeFromDt: value.from ? formatDate(value.from) : formatDate(new Date()),
			noticeEndDt: value.to ? formatDate(value.to) : formatDate(new Date()),
		});
	}, [editSYS4120_R01]);

	return (
		<div className="w-full h-full flex flex-col border border-gray-300 px-[6px] py-[6px] overflow-x-auto">
			<div className="w-full flex items-center">
				<InputForm title="No"			value={editSYS4120_R01?.noticeNo || ''}			editable={false} 					name="noticeNo"				onChange={handleChange} />
				<SingleDateForm
					title="게시일"
					value={editSYS4120_R01?.writerDt ? new Date(editSYS4120_R01.writerDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('writerDt', formatDate(value))}
					editable={false}
					visible={writerDtVisible}				setVisible={setWriterDtVisible}
					onChange={handleChange}
					pickerPos={writerDtPickerPos}						setPickerPos={setWriterDtPickerPos}
				/>
			</div>
			<InputForm title="제목" value={editSYS4120_R01?.noticeTitle || ""} editable={true} wrapperOption={{
				wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[5px]",
				titleStyle: "w-[100px] min-w-[100px] text-left",
				inputStyle: "w-[410px] min-w-[410px]"
			}} name="noticeTitle" onChange={handleChange} />
			
			<CodeForm
				label="게시자"
				value={editSYS4120_R01?.writerEmpNo || ""}
				custNmValue={editSYS4120_R01?.writerEmpNm || ""}
				editable={true}
				handleFoucsId={empInfoHandleFoucsId}
				name="writerEmpNo"
				handleChange={getFieldHandlers('writerEmpNo').onChange}
				onDoubleClick={getFieldHandlers('writerEmpNo').onDoubleClick}
				onKeyDown={getFieldHandlers('writerEmpNo').onEnterKeyDown}
			/>
			<DateRangePickerForm
				label="게시 기간"
				visible={pickerVisible}							setVisible={setPickerVisible}
				editable={true}
				dateRange={editSYS4120_R01?.noticeDateRange ?? { from: new Date(), to: new Date() }}
				setDateRange={handleDateRangeChange as (dateRange: DateRange | undefined) => void}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
			<CheckboxButtonForm
				title="최상단 고정"
				value={editSYS4120_R01?.topNotice || 'N'}
				name="closeTag"
				editable={true}
				onChange={(e) => { setEditSYS4120_R01({
					...defaultSYS4120_R01Row,
					...editSYS4120_R01,
					topNotice: e.target.value === 'Y' ? 'Y' : 'N' }) 
				}}
			/>
			<TextareaForm
				title="본문"
				value={editSYS4120_R01?.noticeComment || ""}
				name="noticeComment"
				editable={true}
				wrapperOption={{
					wrapperStyle: "w-[800px] min-w-[800px] mr-[10px] mb-[5px] h-full",
					titleStyle: "w-[100px] min-w-[100px] text-left",
					inputStyle: "w-[710px] min-w-[710px] h-full"
				}}
				onChange={(e) => { setEditSYS4120_R01({
					...defaultSYS4120_R01Row,
					...editSYS4120_R01,
					noticeComment: e.target.value }) 
				}}
			/>
		</div>
	)
}
